import React from 'react';
import Button from '../elements/button';
import ctaBackground from '../../assets/images/cta-bg.png';
import '../../assets/css/sections/cta.css';
import { Arrow } from '../../assets/icons';
import { useNavigate } from 'react-router-dom';

const CTA = () => {
    const navigate = useNavigate();
    return (
        <section className="cta" style={{ backgroundImage: `url(${ctaBackground})` }}>
            <div className="cta-overlay">
                <div className="cta-content">
                    <h2>Ready to Transform Your Aquaculture Business?</h2>
                    <p>Get expert consultation and start optimizing your facility's health management today</p>
                    <div className="cta-buttons">
                        <Button 
                            text="Book a Consultation"
                            variant="red"
                            icon={<img src={Arrow} alt="arrow" className='arrow_up' />}
                            onClick={() => navigate('/doctors')}
                        />
                        <Button 
                            text="Sign Up Now"
                            variant="primary"
                            icon={<img src={Arrow} alt="arrow" className='arrow_up' />}
                            onClick={() => navigate('/register')}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CTA;